@if (servicePaymentId) {
    <app-table
        [gridData]="$any(store.data.servicePaymentMedicalProcedures$ | async)"
        [columns]="columns"
        translatePrefix="service.payments.medicalProceduresPrices."
        (createCallback)="openAddNew()"
        (deleteCallbackWithEvent)="delete($event)"
        [hideCheckboxes]="true"
        [additionalFilter]="[[{ column: 'servicePaymentId', operator: 'EQ', value: [servicePaymentId.toString()] }]]"
        [refreshCallback]="store.api.getServicePaymentMedicalProcedures"
        [defaultSorters]="[{ column: 'code', direction: 'ASC' }]"
    >
        <ng-template pTemplate="priceForPoint" let-rowIndex="rowIndex">
            <app-number-input
                id="inlinePrice"
                [form]="inlineForms[rowIndex]"
                [showLabel]="false"
                [maxFractionDigits]="2"
            ></app-number-input>
        </ng-template>
    </app-table>
}

<p-dialog
    [header]="'service.payments.medicalProceduresPrices.addNewHeader' | translate"
    [(visible)]="addNewVisible"
    [modal]="true"
    [resizable]="true"
    [maximizable]="true"
>
    <div class="grid-1col input-grid-gaps">
        <app-select-input
            id="code"
            [form]="form"
            [staticOptions]="store.medicalProcedures$ | async"
            [valueKey]="'code'"
            label="service.payments.medicalProceduresPrices.procedure"
            [filterBy]="'code,customCode,customName'">
            <ng-template #item let-data>
                {{ data | formatServiceProcedure }}
            </ng-template>
            <ng-template #selectedItem let-data>
                {{ data | formatServiceProcedure }}
            </ng-template>
        </app-select-input>
        <app-number-input
            id="priceForPoint"
            [form]="form"
            label="service.payments.medicalProceduresPrices.priceForPoint"
            [maxFractionDigits]="2"
        ></app-number-input>
    </div>

    <ng-template pTemplate="footer">
        <app-action-buttons
            (primaryClickEvent)="create()"
            (secondaryClickEvent)="addNewVisible = false"
        ></app-action-buttons>
    </ng-template>
</p-dialog>
